<mat-dialog-content class="medlem-invitasjon-opprett-dialog-innhold">
  <medlem-invitasjon-opprett [gruppe]="gruppe"
                             [visFulltSkjemaHeleTiden]="true"
                             (vedLagret)="vedLagret()"
                             (vedAvbryt)="avbryt()"/>
</mat-dialog-content>
